import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store/index';
import ApiSchoolDiary from '@/api/ApiSchoolDiary';
import {
  ApproveSchoolDiaryRequest,
  ChangeSchoolDiaryRequest,
  ExportSchoolDiaryRequest,
  GetSchoolDiaryRequest,
  PostSchoolDiaryRequest,
  SearchSchoolDiaryRequest,
} from '@/model/Request';
import { SchoolDiaryResponse } from 'chaild-api/lib';

export interface SchoolDiaryState {
  searchResult: { diaries: SchoolDiaryResponse[]; totalItemsCount: number } | null;
  diaryDetail: SchoolDiaryResponse | null;
}

@Module({ dynamic: true, store, name: 'schoolDiary', namespaced: true })
export class SchoolDiaryModule extends VuexModule implements SchoolDiaryState {
  public searchResult: { diaries: SchoolDiaryResponse[]; totalItemsCount: number } | null = null;
  public diaryDetail: SchoolDiaryResponse | null = null;

  @Action({ rawError: true })
  public async searchSchoolDiary(input: SearchSchoolDiaryRequest) {
    const res = await ApiSchoolDiary.searchSchoolDiary(input);
    this.SET_SEARCH_RESULT(res);
    return res;
  }

  @Mutation
  private SET_SEARCH_RESULT(payload: { diaries: SchoolDiaryResponse[]; totalItemsCount: number }) {
    this.searchResult = payload;
  }

  @Action({ rawError: true })
  public async getSchoolDiary(input: GetSchoolDiaryRequest) {
    const res = await ApiSchoolDiary.getSchoolDiary(input);
    this.SET_DIARY_DETAIL(res);
    return res;
  }

  @Mutation
  private SET_DIARY_DETAIL(item: SchoolDiaryResponse) {
    this.diaryDetail = item;
  }

  @Action({ rawError: true })
  public async postSchoolDiary(input: PostSchoolDiaryRequest) {
    return ApiSchoolDiary.postSchoolDiary(input);
  }

  @Action({ rawError: true })
  public async updateSchoolDiary(input: ChangeSchoolDiaryRequest) {
    return ApiSchoolDiary.putSchoolDiary(input);
  }

  @Action({ rawError: true })
  public async deleteSchoolDiary(input: ChangeSchoolDiaryRequest) {
    return ApiSchoolDiary.deleteSchoolDiary(input);
  }

  @Action({ rawError: true })
  public async approveSchoolDiary(input: ApproveSchoolDiaryRequest) {
    return ApiSchoolDiary.approveSchoolDiary(input);
  }

  @Action({ rawError: true })
  public async exportSchoolDiary(input: ExportSchoolDiaryRequest) {
    return ApiSchoolDiary.exportSchoolDiary(input);
  }
}

export const schoolDiaryModule = getModule(SchoolDiaryModule);
